import React, { useRef } from 'react';
import { BottomSheetPlainHeader, HeaderContainer, HeaderHandle, HeaderTitle } from './BottomSheetHeader.styles';

export interface BottomSheetHeaderProps {
  title?: string;
  showHandle?: boolean;
  plain?: boolean;
  handleColor?: string;
  uppercase?: boolean;
  children?: React.ReactNode;
  onSwipeDown?: () => void;
}

const BottomSheetHeader: React.FC<BottomSheetHeaderProps> = ({
  title,
  showHandle = true,
  plain = false,
  handleColor,
  uppercase = false,
  children,
  onSwipeDown
}) => {
  const touchStartY = useRef<number | null>(null);
  const SWIPE_THRESHOLD = 50; // Minimum vertical distance to be considered a swipe

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!touchStartY.current) return;

    const currentY = e.touches[0].clientY;
    const diff = currentY - touchStartY.current;

    // If swiped down more than the threshold, trigger the callback
    if (diff > SWIPE_THRESHOLD && onSwipeDown) {
      onSwipeDown();
      touchStartY.current = null; // Reset to prevent multiple triggers
    }
  };

  const handleTouchEnd = () => {
    touchStartY.current = null;
  };

  if (plain) {
    return (
      <BottomSheetPlainHeader />
    );
  }

  return (
    <HeaderContainer
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {showHandle && <HeaderHandle color={handleColor} />}
      {title && <HeaderTitle $uppercase={uppercase}>{title}</HeaderTitle>}
      {children}
    </HeaderContainer>
  );
};

export default BottomSheetHeader;
